import React, { useContext, useMemo, useEffect, useState, useCallback } from 'react'
import { UserContext } from 'stores/UserStore'
import { useTranslation } from 'react-i18next'
import { FieldDataContext } from 'stores/FieldDataStore'
import { Modal, Card, FlexView, Icon, Button } from 'components/common'
import _ from 'lodash'
import { MultiSelect } from 'components/form'

const FiltersModal = ({ isOpen, onOutsideClick, options }) => {
  const { t } = useTranslation()
  const { registryLog } = useContext(UserContext)
    const {  tableData, filters, setFilters } = useContext(FieldDataContext)
  const [state, setState] = useState({})

  useEffect(() => setState(_.chain(options)
    .keyBy(({ accessor }) => accessor)
    .mapValues((value, key) => _.get(filters, key, []))
    .value()
  ), [options, filters])

  const onInputChange = useCallback(accessor => value => setState(currentState => ({
    ...currentState,
    [accessor]: value
  })), [])

  const renderForm = useMemo(() => {
    return _.map(options, ({ accessor, label, formatter }) => {
      const availableOptions = _.chain(tableData)
        .map(item => {
          const value = _.get(item, accessor)
          return {
            value,
            label: formatter ? formatter(value) : value
          }
        })
        .orderBy('label', 'asc')
        .filter(({ label }) => typeof label === 'string' || typeof label === 'number')
        .uniqBy('value')
        .map(({ value, label }) => ({
          value,
          label: _.toString(label)
        }))
        .value()
      return <MultiSelect
        margin="0px"
        width="100%"
        key={accessor}
        label={label}
        fontSize="small"
        selectedValues={state[accessor]}
        options={availableOptions}
        onChange={onInputChange(accessor)}
      />
    })
  }, [options, state, tableData, onInputChange])

  const onFilterClick = () => {
    //registryLogOld('On Filter', 'field-data')
    registryLog('field-data', 'click', 'filter')
    for (const key of Object.keys(state)) {
      if (state[key].length > 0) {
        //registryLogOld('INPUT - ' + key, 'field-data')
        registryLog('field-data', 'filtering',  key)
      } else {
        delete state[key]
      }
    }    
    setFilters(state)
    onOutsideClick()
  }

  const onClearFilters = () => {
    //registryLogOld('On Clear Filter', 'field-data')
    registryLog('field-data', 'click', 'clear_filter')
    setFilters({})
  }

  return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
    <Card padding="16px" maxWidth="900px" width="50vw">
      <FlexView fontSize="subtitle" fontWeight="bold" flexDirection="row" justifyContent="space-between" alignItems="center" alignSelf="stretch">
        <span>{t('Filters')}</span>
        <Icon name="cross" color="error" width="24px" height="24px" onClick={onOutsideClick} />
      </FlexView>
      <FlexView alignSelf="stretch" margin="0px" padding="0px" height="50vh" style={{ overflow: 'auto' }}>
        {renderForm}
      </FlexView>
      <FlexView flexDirection="row" justifyContent="flex-end" alignItems="center" alignSelf="stretch">
        <Button margin="8px" outline onClick={onClearFilters}>{t('Clear')}</Button>
        <Button margin="8px 0px 8px" color="white" backgroundColor="primary" height="39px" onClick={onFilterClick}>{t('Apply')}</Button>
      </FlexView>
    </Card>
  </Modal>
}

export default FiltersModal
